/**
 * Fetches an order using the provided order token.
 *
 * @param {string} orderToken - The token used to authenticate the request.
 * @param {string} [searchParams] - Optional search parameters as a query string.
 * @returns {Promise<Response>} A promise that resolves to the fetch response.
 */
function getOrderByToken(orderToken, searchParams) {
  let url = pipelineConfig.orderApiUrl
  if (searchParams) {
    const urlObj = new URL(url)
    urlObj.search = searchParams
    url = urlObj.toString()
  }

  return fetch(url, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "x-token": orderToken,
    },
  })
}

/**
 * Fetches an order using the provided funnel fox session token.
 *
 * @param {string} funnelFoxSessionId - The FunnelFox session token used to identify the order.
 * @returns {Promise<Response>} A promise that resolves to to the fetch response.
 */
function getOrderByFFSessionToken(funnelFoxSessionId) {
  const orderApiUrlFiltered = pipelineConfig.orderApiUrl.split("/order")[0]
  const ffSessionUrl = `${orderApiUrlFiltered}/ff-orders/${funnelFoxSessionId}`

  return fetch(ffSessionUrl, {
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  })
}

async function retrieveDataFromApi(dataStore) {
  if (typeof dataStore.pull === "function") {
    const isCommonDataStore = dataStore.pull.toString().includes("pull()") // Check the arity of the pull method
    if (isCommonDataStore) {
      // Series with using common DataStore pull method
      await dataStore.pull()
    } else {
      // Series with legacy dataStore pull method
      await dataStore.pull(false, true)
    }
  } else {
    throw new Error("Data store pull method is not a function or is not defined")
  }
}

export { getOrderByToken, getOrderByFFSessionToken, retrieveDataFromApi }
